import { render, staticRenderFns } from "./CarouselPlugin.vue?vue&type=template&id=008a491f&scoped=true&"
import script from "./CarouselPlugin.vue?vue&type=script&lang=js&"
export * from "./CarouselPlugin.vue?vue&type=script&lang=js&"
import style0 from "./CarouselPlugin.vue?vue&type=style&index=0&id=008a491f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008a491f",
  null
  
)

export default component.exports